import {
  getEndOfDay,
  getTimeZone,
  parseFormInputDate,
} from '@airship-platform/airship-patterns';
import { FlexBox } from '@airship-platform/jam-web/components';
import TextField from '@mui/material/TextField';
import { Controller, useFormContext } from 'react-hook-form';
import { z } from 'zod';

export const PresentationHeaderFormSchema = z.object({
  headline: z.string().max(100).min(1),
  subheadline: z.string().max(100).min(1),
  expiryDate: z.iso.date(),
});

type PresentationHeaderFormInputs = z.infer<
  typeof PresentationHeaderFormSchema
>;

const PresentationHeaderInputs: React.FC = () => {
  const { control, watch } = useFormContext<PresentationHeaderFormInputs>();
  const hasExpired =
    getEndOfDay(parseFormInputDate(watch('expiryDate'))) < getEndOfDay();

  return (
    <FlexBox flexDirection={'column'} gap={2}>
      <Controller
        name={'expiryDate'}
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            type="date"
            label="Proposal expires end of day on"
            error={!!fieldState.error || hasExpired}
            helperText={
              fieldState.error?.message ||
              (hasExpired
                ? 'This proposal has expired'
                : `Your timezone: ${getTimeZone()}`)
            }
          />
        )}
      />
      <Controller
        name={'headline'}
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            label={'Headline'}
            fullWidth
          />
        )}
      />
      <Controller
        name={'subheadline'}
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            label={'Subheadline'}
            fullWidth
          />
        )}
      />
    </FlexBox>
  );
};

export default PresentationHeaderInputs;
